<div class="question-categories-rating-module" *ngIf="questionCategoryRates && questionCategoryRates.length>0">
  <div class="title"> {{ 'lang.reporting.doughnuts' | translate }}</div>
  <div class="row">
    <app-question-categories-doughnut [questionCategoriesRate]="questionCategoriesRate" [categoryIndex]="getCategoryIndex(i, questionCategoriesRate)" 
    *ngFor="let questionCategoriesRate of questionCategoryRates; let i=index;" class="col-3 pdf-doughnut">
    </app-question-categories-doughnut>
  </div>
</div>